export enum ClaimItemTypeEnum {
  WaitingReview = 'waitingReview',
  RetakeRequest = 'retakeRequest'
}
export type ClaimItemType = ClaimItemTypeEnum.WaitingReview | ClaimItemTypeEnum.RetakeRequest;
